module.exports = __webpack_public_path__ + "fonts/symantec_70x70.d1b08926ae67f4a37a238117c3b144db.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/symantec_70x70.png
// module id = 767
// module chunks = 9